import { apiClient } from './index.js';
import { sanitizePostData } from '@/utils/index.js';

async function getOutgoingUserApplications({ showOnlyPending }) {
  const { data } = await apiClient({
    method: 'get',
    url: '/api/UserApplication/GetOutgoingUserApplications',
    params: { ShowOnlyPending: showOnlyPending },
  });
  return data;
}

async function cancelOutgoingApplication({ applicationId }) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/UserApplication/CancelOutgoingApplication',
    data: sanitizePostData({ applicationId }),
  });
  return data;
}

export { getOutgoingUserApplications, cancelOutgoingApplication };
